import { message } from "antd";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { GlobalStateContext } from "../../../utils/GlobalStateContext";
import secureLocalStorage from "react-secure-storage";
import APICaller from "../../../utils/APICaller";

import BeforeTableHeader from "../../layouts/beforeTableHeader";
import CustomLoader from "../../common/customLoader";
import InternalErrorRcaDetails from "./internalErrorRcaDetails";
import "./internalErrorRcaView.css";

const InternalErrorRcaView = () => {
  const { globalState, setGlobalState } = useContext(GlobalStateContext);
  const slsRole = secureLocalStorage.getItem("role");
  const slsToken = secureLocalStorage.getItem("accessToken");

  const location = useLocation();
  const prevData = location?.state;

  const navigate = useNavigate();
  const [showLoader, setShowLoader] = useState(false);
  const id = location.pathname.split("/")[3];

  const getInternalErrorRcaDetail = () => {
    if (window.performance) {
      const entries = performance.getEntriesByType("navigation");
      if (
        secureLocalStorage.getItem("clickedLink") !==
        "clientEscalationDetailLinkClick"
      ) {
        if (entries.length > 0 && entries[0].type === "reload") {
          // Page is refreshed
          secureLocalStorage.setItem(
            "clickedLink",
            "clientEscalationDetailLinkVisit"
          );
        }
      }
    }

    const action = "/internal-error-rca/";
    const endpoint = `${action}${id}`;
    const method = "GET";
    const payload = {};

    APICaller(slsRole, slsToken, endpoint, method, payload)
      .then((response) => {
        setGlobalState((prevGlobalState) => ({
          ...prevGlobalState,
          eDetails: response,
        }));
        setShowLoader(false);
      })
      .catch((error) => {
        error?.data?.message && message.error(error?.data?.message);
      });
  };

  useEffect(() => {
    getInternalErrorRcaDetail();
  }, [location?.state?.route === "/internal-error-rca"]);

  const divStructure = (
    <>
      <img
        src={
          globalState?.auditDetails?.errorImpact === "HIGH"
            ? "/high.png"
            : globalState?.auditDetails?.errorImpact === "MEDIUM"
            ? "/medium.png"
            : "/low.png"
        }
        style={{ width: "17px" }}
        alt="logo"
      />{" "}
      Escalations: {globalState?.auditDetails?.transactionId} From{" "}
      {globalState?.auditDetails?.client?.name}
    </>
  );
  const singlePageContent = { divStructure };
  return (
    <div className="single-page">
      <CustomLoader showLoader={showLoader} />

      <BeforeTableHeader
        singlePage="internalErrorRcaView"
        singlePageContent={singlePageContent}
        list=""
        href=""
      />
      <InternalErrorRcaDetails />
    </div>
  );
};
export default InternalErrorRcaView;
